// IE 2026 10 29 / ODOO-5800 (слово Igor 29.10: «задание рабочего стола и далее название этого стола»): подпись «задания рабочей области» — страницы настроек рабочей области — IE 2026 11 02 / ODOO-349799 (workspace-wording)
// page-settings (utils/settingsPage.js: шаблон бэка WORKSPACE.settings_page, материализованный в PAGES, или страница, ещё лежащая в списке страниц стола).
// Её показывают два окна: панель задач в шапке (пункт _settingsPage группы «Workspace», AppTopbar.tasksSettingsItem) и панель страниц (PagesPanel.items,
// страница с node.value === 'page-settings'). Раньше пункт назывался названием страницы с бэка («Tasks & Workspace settings»); теперь — «Workspace task: {name}»,
// где {name} — название ЭТОГО стола на языке пользователя (title_<lang> стола / записи стола, иначе titleTopBar / title — как подзаголовок панелей).
// Номер и иконка страницы не меняются; поиск панелей идёт по подписи — находит и по префиксу, и по названию стола.
// Выключатель fe.ux.wsTaskLabel (дефолт ВКЛ; false — прежнее название). Чистые функции; юнит — tests/unit/wsTaskLabel.test.mjs.
// IE 2026 10 30 / ODOO-5800 (слово Igor 30.10): подпись — «Workspace settings: {name}» (uk «Налаштування робочої області», ru «Настройка рабочей области» — слово Igor 02.11: Workspace = «Робоча область / Рабочая область»), не «Workspace task». — IE 2026 11 02 / ODOO-349799 (workspace-wording)
import { SETTINGS_PAGE_ID } from './settingsPage.js'

export const WS_TASK_LABEL_FLAG = 'fe.ux.wsTaskLabel'
export const WS_TASK_LABEL_KEY = 'Workspace settings: {name}'   // IE 2026 10 30 / ODOO-5800 (слово Igor 30.10, скрин панели задач «Сигнали»: «по умолчанию имя не задание рабочего стола, а настройка рабочего стола») — было «Workspace task: {name}»

const str = (x) => (typeof x === 'string' ? x.trim() : (typeof x === 'number' ? String(x) : ''))

// выключатель: store.setting(key, default) либо ничего (по умолчанию вкл)
export function wsTaskLabel_on(store) {
    try { return !(store && typeof store.setting === 'function' && store.setting(WS_TASK_LABEL_FLAG, true) === false) } catch (e) { return true }
}

// признак «задание рабочей области»: пункт панели задач с _settingsPage или страница рабочей области page-settings (объект страницы PAGES или её id) — IE 2026 11 02 / ODOO-349799 (workspace-wording)
export function wsTaskLabel_is(x) {
    if (x == null) return false
    if (typeof x === 'string') return x === SETTINGS_PAGE_ID
    if (typeof x !== 'object') return false
    if (x._settingsPage === true) return true
    return String(x.node?.value ?? x.page ?? '') === SETTINGS_PAGE_ID
}

// название стола на языке lang: title_<lang> стола, затем записи стола (не для en — у en суффикса нет), иначе titleTopBar / title / record.title / id стола
export function wsTaskLabel_wsName(WS, lang) {
    if (!WS || typeof WS !== 'object') return ''
    const L = String(lang || '').toLowerCase()
    const rec = (WS.record && typeof WS.record === 'object') ? WS.record : null
    if (L && L !== 'en') {
        const v = str(WS['title_' + L]) || str(rec?.['title_' + L]) || str(rec?.doc?.['title_' + L])
        if (v) return v
    }
    return str(WS.titleTopBar) || str(WS.title) || str(rec?.title) || str(WS.workspace)
}

// подпись: tr — функция перевода t(text, params); названия стола нет — '' (вызывающий оставляет прежнее название)
export function wsTaskLabel_text(WS, lang, tr) {
    const name = wsTaskLabel_wsName(WS, lang)
    if (!name) return ''
    const f = typeof tr === 'function' ? tr : (s, p) => String(s).replace('{name}', p.name)
    return String(f(WS_TASK_LABEL_KEY, { name }) || '')
}

// подпись элемента: флаг вкл, элемент — задание рабочей области и есть её название — новая подпись, иначе fallback (прежнее название) — IE 2026 11 02 / ODOO-349799 (workspace-wording)
export function wsTaskLabel_title(store, WS, x, fallback, lang, tr) {
    if (!wsTaskLabel_on(store) || !wsTaskLabel_is(x)) return fallback
    return wsTaskLabel_text(WS, lang, tr) || fallback
}

export default { WS_TASK_LABEL_FLAG, WS_TASK_LABEL_KEY, wsTaskLabel_on, wsTaskLabel_is, wsTaskLabel_wsName, wsTaskLabel_text, wsTaskLabel_title }
